import { DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingDeleteDialog extends Layout {
    labelDeleteDialog: Label;
    labelHoldMessage: Label;
    panelDeleteDialog: Panel;
    sourceOrders: DataSource;
    switchHold: Switch;
    textboxHoldReason: Textbox;
}
